import isMultipleOf from "./isMultipleOf";
export default function isEven(value) {
    return isMultipleOf(value, 2);
}
